import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import DraggableCustomer from '../customer-record';
import { emptyArray } from 'ui-components/default-props/empty';

const DroppableCustomerRecords = ({ selectedCustomers = emptyArray, survivorCustomerId = '', removeCustomer }) => (
  <div>
    <Droppable droppableId='droppable-id'>
      {(provided) => (
        <div {...provided.droppableProps} ref={provided.innerRef}>
          {selectedCustomers.map((customer, index) => {
            const { marketplaces = [], customerId } = customer;
            const customerProps = {
              ...customer,
              isSurvivor: survivorCustomerId === customerId,
              marketplaces,
              removeCustomer,
            };
            return (
              <DraggableCustomer key={index} customerProps={customerProps} draggableId={`${index} ${customer.customerId}`} index={index} />
            );
          })}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  </div>
);

DroppableCustomerRecords.propTypes = {
  survivorCustomerId: PropTypes.string,
  selectedCustomers: PropTypes.array,
  removeCustomer: PropTypes.func.isRequired,
};

export default DroppableCustomerRecords;
